import React from "react";
import "../../../common/breadcrumbs/styles.css";
import "./../AABI.css";

// A drill-specific breadcrumb (Manufacturer › Category › Group › Product).
// Wrapped in `nav aria-label="Analytics scope"`, items are real buttons, and
// the active item carries aria-current="page" (§11). Reuses
// common/breadcrumbs' CSS classes but changes in-page URL state via onClick —
// the drill position lives in the query params, not the path (§5.4).
const DrillBreadcrumb = ({ items }) => (
  <nav className="aabi-breadcrumb" aria-label="Analytics scope">
    <ul className="breadcrumb-list">
      {items.map((item, index) => {
        const isActive = index === items.length - 1;
        return (
          <li key={`${item.label}-${index}`} className="breadcrumb-item">
            {!isActive && item.onClick ? (
              <button
                type="button"
                className="breadcrumb-link aabi-breadcrumb-link"
                onClick={item.onClick}
              >
                {item.label}
              </button>
            ) : (
              <span
                className="breadcrumb-label"
                aria-current={isActive ? "page" : undefined}
              >
                {item.label}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  </nav>
);

export default DrillBreadcrumb;
